export const accordianItems = [
    {
        id: 1,
        title: "Summary",
        content: "In fact, a recent PWC Global CEO report detailed that 88% of surveyed CEOs think that operational efciency is showing 'very high' or 'high' value returns on digital investment. But it's not all about profts. An Australian hospital, for example, has recently been trialling the technology to help fght superbugs and other bacteria",
    },
    {
        id: 2,
        title: "Introduction",
        content: "In fact, a recent PWC Global CEO report detailed that 88% of surveyed CEOs think that operational efciency is showing 'very high' or 'high' value returns on digital investment. But it's not all about profts. An Australian hospital, for example, has recently been trialling the technology to help fght superbugs and other bacteria",
    },
    {
        id: 3,
        title: "The Problem",
        content: "In fact, a recent PWC Global CEO report detailed that 88% of surveyed CEOs think that operational efciency is showing 'very high' or 'high' value returns on digital investment. But it's not all about profts. An Australian hospital, for example, has recently been trialling the technology to help fght superbugs and other bacteria",
    },
]